import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {
  ENVIRONMENT,
  EnvironmentModel,
} from '@lyceo/lyceo-pupil-app/shared/util-environment';

import { Injectable, inject } from '@angular/core';
import { PersonUsesBookResponse } from './+state/person-uses-book/person-uses-book.model';

@Injectable({
  providedIn: 'root',
})
export class PersonUsesBookService {
  private readonly environment: EnvironmentModel =
    inject<EnvironmentModel>(ENVIRONMENT);
  private readonly http: HttpClient = inject(HttpClient);

  public getLatestPersonUsesBooks(): Observable<PersonUsesBookResponse> {
    const url: string = `${this.environment.practiceApiUrl}/api/person-uses-books`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    const paramsToSend: HttpParams = new HttpParams()
      .set('isActive', true)
      .set('itemsPerPage', 3)
      .set('groups[]', 'full');
    return this.http.get<PersonUsesBookResponse>(url, {
      headers: headersToSend,
      params: paramsToSend,
    });
  }
}
